import { Flex } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'src/components/atoms/Button';
import { OptimizationFormInputs } from './index';

type FooterProps = {
  onCancelClick: () => void;
};
export const Footer: React.FC<FooterProps> = ({ onCancelClick }) => {
  const {
    formState: { isSubmitting },
  } = useFormContext<OptimizationFormInputs>();

  return (
    <Flex justifyContent="flex-end" mt={10}>
      <Button
        buttonName="opt-modal-cancel"
        onClick={onCancelClick}
        backgroundColor="surface.sidebarMuted"
        color="content.body"
        border="1px solid"
        borderColor="surface.border"
        _hover={{ bg: 'sidebar.itemHoverBg' }}>
        Cancel
      </Button>
      <Button
        buttonName="opt-modal-optimize"
        isLoading={isSubmitting}
        backgroundColor="icon.green"
        color="white"
        _hover={{ bg: 'icon.green', opacity: 0.9 }}
        type="submit"
        ml="20px">
        Optimize
      </Button>
    </Flex>
  );
};
